import Link from "next/link";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Predators Seat Upgrades",
    description:
      "Upgrade your tickets and enjoy the game! Upgrades are subject to availability.",
    authRedirectPage: routes.home,
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How do I claim my tickets?",
    answer:
      "You will receive a text when the window to opt in is opened. The opt-in window starts at 9am on game day. After opting in you will have the opportunity to purchase guest tickets & upgrades if they are available.",
  },
  {
    question: "Do I get a ticket to each game on the schedule?",
    answer:
      "Tickets are guaranteed for the three predetermined games in the subscription. There are no penalties for not attending a game, however you do need to confirm your attendance in order to receive a ticket. Please note that your Hat trick Subscription Pass only guarantees you tickets to 3 specific games a month. You can review your monthly schedule on your homepage.",
  },
  {
    question: "Where are my tickets?",
    answer:
      "You will be notified tickets are available 3 hours prior to game start and are delivered within your Ticketmaster Account Manager or the St. Louis Blues app.",
  },
  {
    question: "How are tickets sent to me?",
    answer:
      "3 hours prior to game start you will receive a text confirming that tickets have been delivered to Ticketmaster Account Manager and the St. Louis Blues app.",
  },
  {
    question: "Where will my seats be located?",
    answer:
      "Seats will be located in the Mezzanine Level (upper bowl) around the arena.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer:
      "Hat Trick Subscription Pass tickets, as well as seat upgrades and guest passes, are not eligible for resale or transfer. Abusing these guidelines can result in your Hat Trick Subscription Pass being revoked.",
  },
  {
    question: "Can my seats be changed?",
    answer:
      "Once tickets have been sent to your account, they cannot be changed. Please contact customerservice@stlblues.com for any assistance you may require.",
  },

  {
    question: "Can I bring a friend to a game?",
    answer:
      "Guest tickets & upgrades will be available for select games. If available, guest tickets are available for purchase when you opt into games.",
  },

  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer: "We do not issue any refunds for games you are not able to attend.",
  },
  {
    question: "How can I get a refund and cancel my pass?",
    answer: (
      <>
        An active purchase for the month is not refundable. To cancel your pass
        for the upcoming month opt-out through the{" "}
        <Link
          href={{
            pathname: routes.manage_subscription,
            query: { teamSchema: "stlouisblues_pass" },
          }}
        >
          Manage Subscription
        </Link>{" "}
        tab.
      </>
    ),
  },

  {
    question:
      "How can I change my payment method or update my expiration date?",
    answer: (
      <>
        To update your payment method, simply navigate to the{" "}
        <Link
          href={{
            pathname: routes.manage_subscription,
            query: { teamSchema: "stlouisblues_pass" },
          }}
        >
          Manage Subscription
        </Link>{" "}
        menu on the right side of your screen. You will see a section to update
        your payment method where you can update new information.
      </>
    ),
  },

  {
    question: "How do I renew my subscription?",
    answer: (
      <>
        Your subscription will automatically renew on the 26th of the month!
        There is no action needed on your end to keep your subscription active.
      </>
    ),
  },

  {
    question: "Can I pause my subscription?",
    answer: (
      <>
        Yes, once you navigate to the{" "}
        <Link
          href={{
            pathname: routes.manage_subscription,
            query: { teamSchema: "stlouisblues_pass" },
          }}
        >
          Manage Subscription
        </Link>{" "}
        tab in your account you can elect to pause your subscription for that
        month during the opt out window from the 15th to the 26th. You will
        receive a text message when this period is open.{" "}
      </>
    ),
  },

  {
    question: "Can I cancel my subscription?",
    answer: (
      <>
        Simply navigate to the{" "}
        <Link
          href={{
            pathname: routes.manage_subscription,
            query: { teamSchema: "stlouisblues_pass" },
          }}
        >
          Manage Subscription
        </Link>{" "}
        tab to cancel your subscription. You can only do so during the monthly
        opt out period from the 15th to the 26th of the month.{" "}
      </>
    ),
  },

  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer: "We do not issue any refunds for games you are not able to attend.",
  },

  {
    question: "How can I get a refund and cancel my pass?",
    answer: (
      <>
        An active purchase for the month is not refundable. To cancel your pass
        for the upcoming month opt-out through the{" "}
        <Link
          href={{
            pathname: routes.manage_subscription,
            query: { teamSchema: "stlouisblues_pass" },
          }}
        >
          Manage Subscription
        </Link>{" "}
        tab.
      </>
    ),
  },
];
